import { AxiosService } from './../../../../services/axios.service'
import { movePointsConstants } from './move-points.constants'
import { adminActions, toastActions } from '../../../../actions'

const movePoints = ({
	pointsQuantity: value,
	securityKey
}) => async dispatch => {
	dispatch({ type: movePointsConstants.MOVE_POINTS })
	AxiosService.post('admin/criar-pontos', { securityKey, value }).then(
		({ data }) => {
			dispatch(pointsMoved(data.errors))
		}
	)
}

const pointsMoved = errors => dispatch => {
	dispatch({ type: movePointsConstants.POINTS_MOVED, payload: errors })
	if (!errors || !errors.length) {
		dispatch(toastActions.success({ message: 'Pontos movidos com sucesso' }))
	}
}

const updateSender = sender => dispatch => {
	dispatch({ type: movePointsConstants.UPDATE_SENDER, payload: sender })
	if (sender && sender.id === 1)
		dispatch(adminActions.updateBalancePoints(sender.points))
}

const updateReceiver = receiver => dispatch => {
	dispatch({ type: movePointsConstants.UPDATE_RECEIVER, payload: receiver })
}

const updatePointsToBeMoved = points => dispatch => {
	dispatch({
		type: movePointsConstants.UPDATE_POINTS_TO_BE_MOVED,
		payload: points
	})
}

const addOptions = newOptions => ({
	payload: newOptions,
	type: movePointsConstants.ADD_OPTIONS
})

export {
	addOptions,
	movePoints,
	pointsMoved,
	updateSender,
	updateReceiver,
	updatePointsToBeMoved
}
